var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.app)?_c('v-card-text',[_c('div',{staticClass:"s-vstack"},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Location: "+_vm._s(_vm.store_id)+" - "+_vm._s(_vm.app.store_name))]),_c('div',{staticClass:"subtitle-2"},[_vm._v("Connection is "+_vm._s(_vm.status))]),_c('div',[_c('Webhook')],1),_c('div',[_c('Disconnect')],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }